import { useQuery } from '@tanstack/react-query';

import API from '@/config/api';

import { toolsResponse, type UseTools } from './Tools.schema';

export const toolsKeys = { all: ['tools'] as const };

export const useTools = (opts: UseTools['opts'] = {}) =>
	useQuery<UseTools['response']>({
		...opts,
		queryKey: toolsKeys.all,
		queryFn: () => API.get('/tools').then((res) => toolsResponse.parse(res.data)),
	});
